import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
import { openUrl } from '../../../utils';
export const ViewAction = ({
  url
}) => ({
  id: 'view-content',
  text: /*#__PURE__*/React.createElement(FormattedMessage, messages.view),
  promise: () => openUrl(url)
});